import React, { useEffect, useState } from "react"
import { useNavigate, useSearchParams } from "react-router-dom"
import { apiUrl } from "../../common/config/apiUrl"
import { Container, Row, Col, Card, CardBody, Button } from "reactstrap"
import toast from "react-hot-toast"
import apiHandler from "../../common/config/apiHandler"
import { options } from "toastr"
import CompleteBooking from "../../common/config/complete-booking"
import { inComingIncompleteBooking } from "../../common/config/socket.service"
import SuccessBooking from "../../common/config/success-booking"
import Loader from "../../components/Loader/loader"
import AmendBooking from "../../common/config/amend-booking"
import ExtendBooking from "../../common/config/extend-boooking"
import ShiftBooking from "../../common/config/shift-booking"

const WorldPayResponse = () => {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const sessionId = searchParams.get("sessionId")
  const reference_no = searchParams.get("reference_no")
  const params = new URLSearchParams(
    decodeURIComponent(searchParams.get("str"))
  )
  const obj = Object.fromEntries(params.entries())

  useEffect(() => {
    ;(async () => {
      const response = await apiHandler({
        endpoint: `/backend/payment/check-worldpay-session?site_id=${obj?.site_id}&session_id=${sessionId}`,
        method: "GET",
        options: {
          "x-access-token": localStorage.getItem("token"),
        },
      })

      if (response?.code == 200) {
        if (
          response?.data?.hostedSessionStatus?.transactionState
            ?.transactionState == "SUCCESS"
        ) {
          if (obj?.type === "addCash") {
            console.log(obj,"obj")
            const completeResponse = await SuccessBooking({
              key: obj?.key,
              reference_no,
              company_id: JSON.parse(obj?.company_id),
              payment_type: obj?.payment_type,
              transaction_id:
                response?.data?.hostedSessionStatus?.transactionState?.id,
              payment_intent_id: obj?.payment_intent ? obj?.payment_intent : "",
              user_id: obj?.user_id,
            })
            if (completeResponse?.response_code === 200) {
              inComingIncompleteBooking({
                data: { reference_no: reference_no },
                token: obj?.key,
              })

              toast.success(completeResponse?.data)

              navigate("/allBookings")
            }
          } else if (obj?.type == "incomplete") {
            const updatedCombinedData = {
              key: obj?.key,
              admin_charges: obj?.admin_charges,
              reference_no,
              company_id: JSON.parse(obj?.company_id),
              extra_amount: JSON.parse(obj?.extra_amount),
              sms_confirmation: JSON.parse(obj?.sms_confirmation),
              cancellation_status: JSON.parse(obj?.cancellation_status),
              payment_type: obj?.payment_type,
              transaction_id:
                response?.data?.hostedSessionStatus?.transactionState?.id,
              payment_intent_id: obj?.payment_intent ? obj?.payment_intent : "",
              user_id: obj?.user_id,
            }

            const completeResponse = await CompleteBooking(updatedCombinedData)
            if (completeResponse?.response_code === 200) {
              inComingIncompleteBooking({
                data: { reference_no: updatedCombinedData.reference_no },
                token: updatedCombinedData.key,
              })

              toast.success(completeResponse?.data)

              navigate("/allBookings")
            }
          } else if (obj?.type == "editbooking") {
            const amendResponse = await AmendBooking({
              site_id: obj?.site_id,
              reference_no,
              title: obj?.title,
              first_name: obj?.name.split(" ")[0],
              last_name: obj?.name.split(" ")[1],
              email: obj?.email,
              contact_no: obj?.contact_no,
              make: obj?.make,
              model: obj?.model,
              color: obj?.color,
              reg_no: obj?.reg_no,
              departure_time: obj?.departure_time,
              arrival_time: obj?.arrival_time,
              departure_terminal: obj?.departure_terminal,
              departure_flight_no: obj?.departure_flight_no,
              arrival_terminal: obj?.arrival_terminal,
              arrival_flight_no: obj?.arrival_flight_no,
              no_of_peoples: obj?.no_of_peoples,
              company_email: obj?.company_email,
              customer_email: obj?.customer_email,
              key: obj?.key,
              user_id: obj?.user_id,
              extar_amount: obj?.extra_amount,
              payment_type: obj?.payment_type,
              transaction_id:
                response?.data?.hostedSessionStatus?.transactionState?.id,
            })

            if (amendResponse?.response_code === 200) {
              toast.success(amendResponse?.data)
              navigate("/allBookings")
            }
          } else if (obj?.type == "amendBooking") {
            const extendResponse = await ExtendBooking({
              key: obj?.key,
              user_id: obj?.user_id,
              site_id: obj?.site_id,
              reference_no,
              company_id: JSON.parse(obj?.company_id),
              departure: obj?.departure,
              arrival: obj?.arrival,
              amount: obj?.amount,
              extar_amount: JSON.parse(obj?.extra_amount),
              payment_type: obj?.payment_type,
              transaction_id:
                response?.data?.hostedSessionStatus?.transactionState?.id,
              payment_intent_id: obj?.payment_intent ? obj?.payment_intent : "",
              company_email: obj?.company_email,
              customer_email: obj?.customer_email,
            })

            if (extendResponse?.response_code === 200) {
              toast.success(extendResponse?.data)
              navigate("/allBookings")
            }
          } else if (obj?.type == "shiftBooking") {
            const shiftResponse = await ShiftBooking({
              key: obj?.key,
              user_id: obj?.user_id,
              site_id: obj?.site_id,
              reference_no,
              company_id: JSON.parse(obj?.company_id),
              airport: obj?.airport,
              departure: obj?.departure,
              arrival: obj?.arrival,
              amount: obj?.amount,
              extra_amount: JSON.parse(obj?.extra_amount),
              payment_type: obj?.payment_type,
              transaction_id:
                response?.data?.hostedSessionStatus?.transactionState?.id,
              payment_intent_id: obj?.payment_intent ? obj?.payment_intent : "",
              sms: obj?.sms,
              customer_email: obj?.customer_email,
              company_email: obj?.company_email,
            })

            if (shiftResponse?.response_code === 200) {
              toast.success(shiftResponse?.message)
              navigate("/allBookings")
            }
          }
        }
      }
    })()
  }, [])

  return (
    <Container
      className="d-flex align-items-center justify-content-center "
      style={{
        height: "90vh",
      }}
    >
      <Row className="justify-content-center w-75">
        <Col md={8}>
          <Card className="text-center shadow-lg">
            <CardBody>
              <h1 className="text-primary mb-4 h5">
                Please wait we are fetching our customer detail...
              </h1>
              {/* <Button color="primary" onClick={() => window.location.href = "/dashboard"}>
                Go to dashboard
              </Button> */}
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  )
}

export default WorldPayResponse
